<template>
  <div class="contentHome">
    <div class="centerPage">
      <tabCommon></tabCommon>
      <div class="right">
        <div class="title flex">
          <span>心理测试</span>
          <div class="btnTab">
            <el-button size="mini" @click="changeStatus(0,-1)" :class="active==0?'activeIndex':''">全部({{ count.all }})
            </el-button>
            <el-button size="mini" @click="changeStatus(1,0)" :class="active==1?'activeIndex':''">待测试({{ count.s0 }})
            </el-button>
            <el-button size="mini" @click="changeStatus(2,1)" :class="active==2?'activeIndex':''">待结果({{ count.s1 }})
            </el-button>
            <el-button size="mini" @click="changeStatus(3,2)" :class="active==3?'activeIndex':''">待评价({{ count.s2 }})
            </el-button>
            <el-button size="mini" @click="changeStatus(4,3)" :class="active==4?'activeIndex':''">已完成({{ count.s3 }})
            </el-button>
          </div>
        </div>
        <div class="formUserInfo">
          <div class="cnHomeTabsItem flex"
               v-for="(obj,index) in page.rows"
               :key="index">
            <div class="avatar img" :style="'backgroundImage: url('+obj.exam.exhibitImg+')'"></div>
            <div class="rightHome">
              <div class="flex">
                <span><strong>{{ obj.exam.title }}</strong></span>
                <span>测试单号：{{ obj.resultNo }}</span>
              </div>
              <p>
                <span>测试费用：<span class="cost">￥{{ obj.expense }}</span></span>
              </p>
              <div class="flex">
                <span
                    :class="(obj.examStatus==1||obj.examStatus==2)?'cost':'green'">{{ obj.examStatus| statusFmt }}</span>
                <div>
                  <el-button v-if="obj.examStatus==0" size="mini" class="solid" @click="toExamDetails(obj.exam.id)">
                    去测试
                  </el-button>
                  <el-button v-if="obj.examStatus>0" size="mini" @click="toDetail(obj.resultNo)">
                    查看{{ (obj.examStatus == 2) ? '结果' : '详情' }}
                  </el-button>
                  <el-button v-if="obj.examStatus==2" size="mini" @click="toDetail(obj.resultNo)" class="solid">去评价
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="empty" v-if="page.rows.length==0 || !page.rows[0].exam.id">
            <img src="../../assets/img/no.png" alt="" width="200">
            <p>这里什么都没有</p>
          </div>
          <el-pagination
              class="pagination"
              background
              prev-text="Prev"
              next-text="Next"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "psyTest",
  data() {
    return {
      active: 0,
      count: {
        all: 0,
        s0: 0,
        s1: 0,
        s2: 0,
        s3: 0
      },
      page: {
        current: 1,
        size: 5,
        total: 0,
        rows: [],

        status: -1,
      }
    }
  },
  components: {
    'tabCommon': () => import('./tabCommon'),
  },
  mounted() {
    this.$ajax.get(base.api.exam.result.count).then((res) => {
      if (res.data.status === 'success') {
        this.count = res.data.data;
        this.getData();
      }
    });
  },
  methods: {
    changeStatus(index, status) {
      this.active = index;
      this.page.status = status;
      this.getData();
    },
    toExamDetails(id) {
      this.$router.push({name: 'examDetail', query: {back: '1', id: id}});
    },
    toDetail(no) {
      this.$router.push({name: 'psyTestDetail', query: {no: no}})
    },
    getData() {
      this.$ajax.get(base.api.exam.result.list, {
        params: {
          current: this.page.current,
          size: this.page.size,
          status: this.page.status
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        }
      });
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
    },
  },
  filters: {
    statusFmt(status) {
      switch (status) {
        case 0:
          return "待测试";
        case 1:
          return "待结果";
        case 2:
          return "待评价";
        case 3:
          return "已完成";
      }
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.cnHomeTabsItem {
  .avatar {
    width: 150px;
    height: 75px;
  }

  .rightHome {
    width: calc(100% - 170px);
  }
}

</style>
